import { CarryOutOutlined, ScheduleOutlined } from '@ant-design/icons';

export const CREATION_MODE_OPTIONS = [
  { value: 'separate_tasks', label: 'Separate tasks', icon: <ScheduleOutlined /> },
  { value: 'one_task', label: 'Single task', icon: <CarryOutOutlined /> },
];
